export { default } from './MultiValueLabel';
